
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import noRideImage from '../../../assets/NoRide.png'; // Adjust the path as needed

function NoRide() {
  const navigate = useNavigate(); // Initialize navigate

  const handleNavigate = () => {
    navigate('/product'); 
  };

  return (
    <div className="flex flex-col h-screen w-full bg-gray-50">
      {/* Header */}
      <div className="w-full bg-[#FF9630] py-4 px-6 flex items-center">
        <button className="text-white text-lg font-semibold">&larr;</button>
        <h1 className="text-white text-lg font-semibold ml-4">My Ride</h1>
      </div>

      {/* Content */}
      <div className="flex flex-col items-center justify-center">
        <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-sm flex flex-col items-center">
          {/* Image */}
          <div className="mb-6">
            <img
              src={noRideImage}
              alt="No List Found"
              className="w-32 h-32"
            />
          </div>
          {/* Text */}
          <h2 className="text-gray-700 font-bold text-lg mb-2">No list Found</h2>
          <p className="text-gray-500 text-sm mb-6">Start your ride, any time</p>
          {/* Button */}
          <button
            onClick={handleNavigate} // Add onClick handler
            className="bg-[#FF9630] text-white font-medium py-2 px-6 rounded-lg"
          >
            Browse Our Fleet
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoRide;
